import { AppState } from 'src/app/store'
import { Deposit, RemoveDepositValidator, ExportDepositValidator } from 'src/core/models'

export const getDepositsListSelector = (state: AppState) => state.deposits.list
export const depositListSelector = (state: AppState) => state.deposits.list.deposits
export const filteredDepositsSelector = (state: AppState) => state.deposits.list.filteredDeposits
export const selectedDepositsSelector = (state: AppState) => state.deposits.list.selectedDeposits
export const filterDepositTextSelector = (state: AppState) => state.deposits.list.filterText
export const removeDepositsSelector = (state: AppState) => state.deposits.list.removeDeposits
export const fetchDepositSelector = (state: AppState) => state.deposits.fetchDeposit

export const canExportDepositsSelector = (state: AppState): ExportDepositValidator => {
  const deposits = state.deposits.list.selectedDeposits
  if (deposits.length === 0) return 'EMPTY_ERROR'
  else if (deposits.find((d: Deposit) => d.status !== 'paid')) return 'ONLY_PAID_ERROR'
  return 'SUCCESS'
}

export const canDeleteDepositsSelector = (state: AppState): RemoveDepositValidator => {
  const deposits = state.deposits.list.selectedDeposits
  if (deposits.length === 0) return 'EMPTY_ERROR'
  else if (deposits.find((d: Deposit) => d.status === 'paid')) return 'ONLY_PENDING_ERROR'
  return 'SUCCESS'
}

export const completedDepositsSelector = (state: AppState) => {
  return state.deposits.list.deposits.filter((d: Deposit) => d.status === 'paid')
}

export const validateDepositSelector = (state: AppState) => state.deposits.validateDeposit
export const cancelDepositSelector = (state: AppState) => state.deposits.cancelDeposit
